import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../config/firebase";
import { sendEmail, signUp } from "../../apiCalls/userApiCalls";
import { errNotification } from "../common/notification";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { signUpFailure, signUpStart } from "../../redux/reduxSlice/authRedux";

export default function UserDetailsForm(props) {
  const { signInData, handleNext, handleBack, setSignInData } = props;
  const [file, setFile] = React.useState(null);
  const [errFile, setErrFile] = React.useState("");
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().min(4).required("Last name is required"),
    classId: Yup.string().required("ClassId is required"),
    phone: Yup.string().min(4).required("Phone No is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
  });

  async function uploadData(values, setSubmitting) {
    const fileName = `slip/${new Date().getTime()} - ${file.name}`;
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          console.log({ ...signInData, ...values, dpUrl: downloadURL });
          const user = {
            ...signInData,
            ...values,
            slip: downloadURL,
          };
          signUp(user, dispatch)
            .then((res) => {
              setSignInData((prev) => ({ ...prev, classId: res.classId }));
              sendEmail(res.email, res.classId);
              setSubmitting(false);
              handleNext();
            })
            .catch((err) => {
              dispatch(signUpFailure());
              setSubmitting(false);
              errNotification("Sign In Failed!!!");
            });
        });
      }
    );
  }
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      classId: signInData.state === "nonRegistered" ? "test" : "",
      phone: "",
      email: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (file) {
          dispatch(signUpStart());
          setSignInData((prev) => ({ ...prev, ...values }));
          await uploadData(values, setSubmitting);
        } else {
          setErrFile("Please select a file");
        }
      } catch (error) {
        setSubmitting(false);
      }
    },
  });

  return (
    <React.Fragment>
      <ToastContainer />
      <FormikProvider value={formik}>
        <Form autoComplete="off" onSubmit={formik.handleSubmit}>
          <React.Fragment>
            <Typography variant="h6" gutterBottom>
              User Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  id="firstName"
                  label="First Name"
                  fullWidth
                  variant="standard"
                  name="firstName"
                  onChange={formik.handleChange}
                  value={formik.values.firstName}
                />
                <ErrorMessage name="firstName">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="lastName"
                  label="Last Name"
                  fullWidth
                  variant="standard"
                  name="lastName"
                  onChange={formik.handleChange}
                  value={formik.values.lastName}
                />
                <ErrorMessage name="lastName">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
              {signInData.state !== "nonRegistered" && (
                <Grid item xs={12} md={6}>
                  <TextField
                    id="classId"
                    label="Class ID"
                    fullWidth
                    variant="standard"
                    name="classId"
                    onChange={formik.handleChange}
                    value={formik.values.classId}
                    disabled={
                      signInData.state === "nonRegistered" ? true : false
                    }
                  />
                  <ErrorMessage name="classId">
                    {(msg) => (
                      <div
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "12px",
                        }}
                      >
                        {msg}
                      </div>
                    )}
                  </ErrorMessage>
                </Grid>
              )}
              <Grid item xs={12} md={6}>
                <TextField
                  id="phone"
                  label="Phone No"
                  fullWidth
                  variant="standard"
                  name="phone"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
                <ErrorMessage name="phone">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  id="email"
                  label="Email"
                  fullWidth
                  variant="standard"
                  name="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                <ErrorMessage name="email">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  component="label"
                  sx={{
                    mt: 2,
                  }}
                >
                  Upload Slip
                  <input
                    type="file"
                    hidden
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </Button>
                <div
                  style={{ color: "red", textAlign: "left", fontSize: "12px" }}
                >
                  {errFile}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h10">
                  <div style={{ color: "blue", fontSize: "16px" }}>
                    {file && file.name}
                  </div>
                </Typography>
              </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                Back
              </Button>
              <Button
                variant="contained"
                sx={{ mt: 3, ml: 1, width: "100px" }}
                type="submit"
                disabled={user.isFetching}
              >
                {user.isFetching ? (
                  <CircularProgress size={20} color="success" />
                ) : (
                  "Sign Up"
                )}
              </Button>
            </Box>
          </React.Fragment>
        </Form>
      </FormikProvider>
    </React.Fragment>
  );
}
